module.exports = __webpack_public_path__ + "img/catagory3.3ccaf696.png";